import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { APP_VERSION, isFirstVisit, isVersionOutdated, setStoredVersion } from "@/lib/version";

export const useVersionCheck = () => {
  const hasShownNotification = useRef(false);

  useEffect(() => {
    if (hasShownNotification.current) return;

    const isOutdated = isVersionOutdated();

    if (isOutdated) {
      hasShownNotification.current = true;

      toast.info("App Update Detected", {
        description:
          "We've detected that your browser may have cached an older version of the app. Please clear your browser cache and refresh the page to ensure optimal performance.",
        duration: 10000,
        action: {
          label: "Refresh Page",
          onClick: () => window.location.reload(),
        },
      });

      setStoredVersion(APP_VERSION);
    } else if (isFirstVisit()) {
      setStoredVersion(APP_VERSION);
    }
  }, []);
};
